import { render, staticRenderFns } from "./card-doctor.vue?vue&type=template&id=4a3aa6d3&scoped=true"
import script from "./card-doctor.vue?vue&type=script&lang=js"
export * from "./card-doctor.vue?vue&type=script&lang=js"
import style0 from "./card-doctor.vue?vue&type=style&index=0&id=4a3aa6d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3aa6d3",
  null
  
)

export default component.exports